import React from "react";
import PropTypes from "prop-types";

import styles from "./Placeholder.css";

export default function Placeholder(props) {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.placeholder}>
        <span>{props.children}</span>
      </div>
    </div>
  );
}

Placeholder.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

Placeholder.defaultProps = {
  isVisible: true,
};
